export default {
      id: "i-dzen-black-usage",
      viewBox: "0 0 33 33",
      url: __webpack_public_path__ + "img/sprite.svg#i-dzen-black",
      toString: function () {
        return this.url;
      }
    }